export const memberScrollbarCss = {
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'brandGray.darker',
    borderRadius: '18px',
  },
};
